var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._b(
      {
        ref: "select",
        class: { isView: _vm.mode !== "edit" },
        attrs: {
          value: _vm.inputVal,
          placeholder: _vm.placeholderTxt,
          clearable: _vm.clearable,
          filterable: "",
          disabled: _vm.isDisabled,
        },
        on: { change: _vm.onChange },
      },
      "el-select",
      _vm.$attrs,
      false
    ),
    _vm._l(_vm.options, function (item, index) {
      return _c("el-option", {
        key: index,
        attrs: { label: item[_vm.labelKey], value: item[_vm.valueKey] },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }